<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" role="doc-part">
<p class="image"><img alt="Image" src="images/part01.jpg"/><span aria-label="page 12" id="page_12" role="doc-pagebreak"><span aria-label="page 13" id="page_13" role="doc-pagebreak"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?61844578